import BreakStepManagementAccordion from 'hoc/BreakStepManagementAccordion';

export default {
  key: 'breakStepManagement',
  props: {
    headerKey: 'editbreak.section.steps.heading'
  },
  custom: BreakStepManagementAccordion
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breakStepManagementSection.js